const messages = {
    en: {
        save: 'Save',
        delete: 'Delete',
        subscriptions: 'Subscriptions',
        selectSubscription: 'Select Subscription',
        search: 'Search',
        select: 'Select',
        selectAll: 'Select All',
        cancel: 'Cancel',
        close: 'Close',
        confirmDelete: 'Confirm Delete',
        areYouSureDelete: 'Are you sure you want to delete this item?',
        actionPermanent: 'This action is permanent.',
        leave: 'Leave',
        reset: 'Reset',
        remove: 'Remove',
        ok: 'Ok',
        add: 'Add',
        yes: 'Yes',
        no: 'No',
        date: 'Date',
        status: 'Status',
        filter: 'Filter',
        startDate: 'Start Date',
        endDate: 'End Date',
        apply: 'Apply',
        confirm: 'Confirm',
        today: 'Today',
        inactive: 'Inactive',
        authentication: {
            email: 'Email',
            password: 'Password',
            login: 'Login',
            rememberMe: 'Remember me',
            forgotPassword: 'Forgot password?',
            loginWithFacebook: 'Login with Facebook',
            loginWithGoogle: 'Login with Google',
            loginWithApple: 'Login with Apple',
            createSubscription: 'Create subscription',
            paySubscription: 'Pay subscription',
            subscriptionName: 'Subscription name',
            firstName: 'First Name',
            lastName: 'Last Name',
            confirmEmail: 'Confirm email',
            confirmPassword: 'Confirm Password',
            address: 'Address',
            payCreateSubscription: 'Pay and create subscription',
            pay: 'Pay',
            cardNumber:' Card Number',
            alreadyHaveAccount: 'Already have an account?',
            logIn: 'Log In',
            resetPassword: 'Reset Password',
            setPassword: 'Set Password',
            newPassword: 'New Password',
            repeatNewPassword: 'Repeat new password',
            phoneNumber: 'Phone number',
            registration: 'Registration',
            register: 'Register',
            name: 'Name',
        },
        menu: {
            circles: 'Circles',
            zones: 'Zones',
            locations: 'Locations',
            notifications: 'Notifications',
            alerts: 'Alerts',
            payments: 'Payments',
            logout: 'Logout',
            openTour: 'Open Tour',
            account: 'Account',
            settings: 'Settings',
            usersLocations: 'Users and Locations',
        },
        errors: {
            requestTimeout: 'Request timeout',
            invalidEmail: 'Invalid email',
            IncorrectLogin: 'Username or password is incorrect.',
            AccountNotActive: 'Account is not active.',
            TokenNotValid: 'The token is not valid.',
            TokenNotFound: 'The token is not found.',
            TokenExpired: 'The token expired.',
            CannotConfirmAccount: 'Cannot confirm the account.',
            CannotUpdatePassword: 'Cannot update the password.',
            UserNotFound: 'This user cannot be found.',
            OldPasswordIncorrect: 'The old password is incorrect.',
            OrganizationNotFound: 'The subscription was not found.',
            InsufficientPermissions: 'You do not have permission to this',
            EmailFormatNotValid: 'The Email format is not valid',
            SubscriptionMemberLimitReached: ' You reached your subscription member limit.',
            CannotCreateInvitation: 'The invitation cannot be sent.',
            OrganizationUserNotFound: 'This user could not be found in this subscription.',
            CircleUserAlreadyExists: 'This user already exists',
            PhoneNumberUsedByAnotherUser: 'This phone number is used by another user.',
            UserSubscriptionAlreadyExists: 'This user is already exists.',
            required: 'Required',
            passwordFormat: 'The password should contain an uppercase, lowercase character and a number.',
            numberFormat: 'The field can only contain numeric values.',
            minimumItem: 'You should add minimum one item to the table.',
            numberDecimalFormat: 'The field can only contain numeric values with one decimal place.',
            savingData: 'There was an error while saving the data.',
            wrongFileType: 'Wrong file type. You can upload ',
            passwordsNotMatch: 'Password and confirm password do not match.',
            emailsNotMatch: 'Email and confirm email do not match.',
            serverError: 'Server error',
            notValidColor: 'This is not a valid color. Example: #AA55B1',
            NoUsersFoundToNotify: 'There are no users found to notify.',
            AlertNotFound: 'Alert not found',
            OperationNotPermitted: 'Operation is not permitted.',
            InvalidUserAccount: 'Invalid user account.',
        },
        success: {
            activateEmailSuccessful: 'The activation was successful.',
            registrationSuccessful: 'The registration was successful. Please log in.',
            registrationSuccessActivateAccount: 'The registration was successful. Please activate your account by clicking the link in the email.',
            passwordResetSent: 'Your password reset email was sent.',
            resetPasswordSuccess: 'Your password has been reset successfully.',
            circleCreatedSuccessful: 'The circle was created successfully.',
            circleUpdatedSuccessful: 'The circle was updated successfully.',
            invitationSentSuccessful: 'The invitation was sent successfully.',
            invitationAcceptSuccessful: 'The invitation was accepted successfully.',
            usersAdded: 'The users were added successfully.',
            notificationSent: 'The notification was sent successfully.',
            userRoleChange: 'The user role was changed.',
            userNotificationStatus: 'The user notification status was changed.',
            passwordWasChanged: 'Password was changed.',
            profileWasUpdated: 'Profile was updated.',
            organizationWasUpdated: 'Subscription was updated.',
            alertsWasUpdated: 'Alerts was updated.',
            notificationsWasUpdated: 'Notifications was updated.',
            subscriptionWasCreated: 'The new subscription was created.',
            settingsWasUpdated: 'Settings were updated.',
            zoneWasCreated: 'Zone was created successfully.',
            zoneWasUpdated: 'Zone was updated successfully.',
            geofenceWasUpdated: 'Geofence was updated successfully.',
            invitationWasResent: 'The invitation was resent.',
            userRoleWasUpdated: 'The user\'s role was updated.',
            confirmTokenSent: 'The confirmation token was sent.',
            phoneConfirmed: 'The phone number was confirmed successfully.',
        },
        warnings: {
            noLocationHistory: 'This user does not have location history',
            areYouSureLeave: 'Are you sure you want to leave this page?',
            thereAreUnsavedChanges: 'There are unsaved changes.',
            confirmLeavePage: 'Confirm Leave Page',
            unsavedChanges: 'There are unsaved changes.',
            notSupportAudio: 'Your browser does not support the audio element.',
            needSelectDate: 'You need to select a date.',
            noActiveSubscriptionRenew: 'You have no active subscriptions, please create a new one.',
            noActiveSubscription: 'You have no active subscriptions, please create a new one.',
            unreadAlerts: 'There are unread alerts',
            unreadNotifications: 'There are unread notifications',
            unreadAlertsAndNotifications: 'There are unread alerts and notifications',
        },
        circles: {
            map: 'Map',
            myCircles: 'My Circles',
            createCircle: 'Create Circle',
            label: 'Label',
            circleName: 'Circle Name',
            administrator: 'Administrator',
            management: 'Management',
            avatar: 'Avatar',
            details: 'Details',
            config: 'Config',
            memberInfo: 'Member Info',
            receiveNotifications: 'Receive notifications',
            user: 'User',
            manager: 'Manager',
            role: 'Role',
            addMember: 'Add member',
            addToCircle: 'Add to Circle',
            inviteUserToApp: 'Invite user to app',
            showAllCircles: 'Show All Circles',
            owner: 'Owner',
            noCircleHistory: 'There is no circle history',
        },
        tooltips: {
            edit: 'Edit',
            delete: 'Delete',
            inviteToCircle: 'Invite to circle',
            removeFromCircle: 'Remove from circle',
            deleteCircle: 'Delete Circle',
            addNewMember: 'Add a new member',
            sendNotification: 'Send a notification',
            users: 'Users',
            settings: 'Settings',
            editCircleName: 'Edit Circle Name',
            editZone: 'Edit Zone',
            addZone: 'Add Zone',
            members: 'Members',
            resendInvitation: 'Resend Invitation',
            makeAdmin: 'Make admin',
            removeAdmin: 'Remove from admins',
            deleteUser: 'Delete User',
            locationHistory: 'Location History',
            moreDetails: 'More Details',
            circleHistory: 'Circle History',
        },
        notifications: {
            markSelectedAsRead: 'Mark selected as read',
            history: 'History',
            title: 'Title',
            message: 'Message',
            severity: 'Severity',
            info: 'Info',
            warning: 'Warning',
            critical: 'Critical',
            to: 'To',
            all: 'All',
            users: 'Users',
            sendNotification: 'Send notification',
            groups: 'Groups',
            notificationDetails: 'Notification Details',
            channel: 'Channel',
            pending: 'Pending',
            completed: 'Completed',
            failed: 'Failed',
            sentTo: 'Sent to',
            viewedAt: 'Viewed At',
            insideZone: 'Inside the selected zone',
            outsideZone: 'Outside the selected zone',
            sendNotificationUsers: 'Send notification to users',
        },
        account: {
            oldPassword: 'Old Password',
            newPassword: 'New Password',
            confirmNewPassword: 'Confirm New Password',
            theme: 'Theme',
            light: 'Light',
            dark: 'Dark',
            changePassword: 'Change Password',
            subscriptions: 'Subscriptions',
            myProfile: 'My Profile',
            createNewSubscription: 'Create new subscription',
            areYouSureLeaveOrganization: 'Are you sure you want to leave this subscription?',
            areYouSureRemoveOrganization: 'Are you sure you want to remove this subscription?',
            changeAvatar: 'Change Avatar',
            removeAvatar: 'Remove Avatar',
            enterConfirmationCode: 'Enter confirmation code',
            confirmPhoneNumber: 'Confirm Phone Number',
            confirmed: 'Confirmed',
        },
        settings: {
            accentColor: 'Accent Color',
            textAccentColor: 'Text Accent Color',
            Email: 'Email',
            SMS: 'SMS',
            Realtime: 'Push Notifications',
            alerts: 'Alerts',
            myOrganization: 'My subscription',
            uploadLogo: 'Upload Logo',
            changeLogo: 'Change Logo',
            removeLogo: 'Remove Logo',
            timezone: 'Timezone',
            notificationAlerts: 'Notifications and Alerts',
        },
        zones: {
            myZones: 'My Zones',
            normal: 'Normal',
            safe: 'Safe',
            danger: 'Danger',
            drag: 'Drag',
            circle: 'Circle',
            polygon: 'Polygon',
            editName: 'Edit Name',
            zoneName: 'Zone Name',
            showAllZones: 'Show All Zones',
            createZone: 'Create Zone',
            name: 'Name',
            zoneManagement: 'Zone Management',
            geofenceHistory: 'Geofence History',
            eventIn: 'Event In',
            eventOut: 'Event Out',
            geofenceEvent: 'Geofence Event',
            monitoredMembers: 'Monitored Members',
            notificationReceivers: 'Notification Receivers',
            addMonitoredMembers: 'Add Monitored Members',
            addNotificationReceivers: 'Add Notification Receivers',
            management: 'Management',
            type: 'Type',
            noHistoryOfGeofenceEvents: 'No history of geofence events.',
            youShouldSelectOneEvent: 'At least one event should be selected',
            areYouSureRemoveCurrentShape: 'Resetting the shape will delete it.  Are you sure you want to continue?',
            confirmReset: 'Confirm Reset',
        },
        user: {
            active: 'Active',
            invited: 'Invited',
            admin: 'Admin',
            columnSettings: 'Column Settings',
            joinDate: 'Join Date',
            lastSeenAt: 'Last Seen At',
            lastLoginAt: 'Last Login At',
            confirmRoleChange: 'Confirm Role Change',
            areYouSureChangeRole: 'Are you sure you want to change this user\'s role?',
            areYouSureDeleteUser: 'Are you sure you want to delete this user from your subscription?',
            change: 'Change',
            location: 'Location',
            interval: 'Interval',
        },
        locations: {
            lastHours: 'Last {h} hours',
            lastDay: 'Last day',
            lastDays: 'Last {d} days',
            lastWeek: 'Last week',
        },
        alerts: {
            scheduledAlerts: 'Alerts\' Schedules',
            sender: 'Sender',
            alertType: 'Alert Type',
            download: 'Download',
            details: 'Details',
            media: 'Media',
            alertDetails: 'Alert Details',
            senderEmail: 'Sender Email',
            noLocationData: 'There is no location data.',
            noAlertHistory: 'There is no alert history.',
            noScheduledAlerts: 'There is no scheduled alerts.',
            displayLastTen: 'Displaying last ten records. For more, please use the date filter.',
            recurring: 'Recurring',
            gracePeriod: 'Grace Period',
            day: 'Day',
            dayOfWeek: 'Day of week',
            times: 'Times',
            alertScheduleDetails: 'Alert Scheduled Details',
            allPeople: 'All People',
        },
        subscription: {
            expired: 'Expired',
            renewalDate: 'Renewal Date',
            billingPlan: 'Billing Plan',
            activeMembersRemaining: 'Active Members / Available Invitations',
            SMSVolumeRemaining: 'SMS Volume / Remaining SMS',
            subscriptionDetails: 'Subscription Details',
        }
    },
    ro: {},
};
export default messages;
